import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react/react/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import { ComponentStatuses } from '../src/component-statuses';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Note = makeShortcode("Note");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Note mdxType="Note">
      <p>{`See the `}<a parentName="p" {...{
          "href": "https://primer.style/contribute/component-lifecycle"
        }}>{`component lifecycle`}</a>{` for more information about each status.`}</p>
    </Note>
    <ComponentStatuses mdxType="ComponentStatuses" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      